import {
  computed, flow, makeObservable, observable,
} from 'mobx';

import { CaseAdapter } from '@shared/CaseAdapter';
import BaseStore from './BaseStore';
import OpenDrivingSchoolApi, { ComponentsFrontendType, ComponentsType } from '../api/open_driving_school_api';

class OpenDrivingSchoolProposalStore extends BaseStore {
  isComponentsDataLoading = false;
  initialComponents: ComponentsType[] = [];
  isSending = false;
  isApplicantLoading = false;
  applicant = {};

  constructor() {
    super();

    makeObservable(this, {
      isComponentsDataLoading: observable,
      componentsGroupedByCategory: computed,
      initialComponents: observable,
      parsedComponents: computed,
      isSending: observable,
      isApplicantLoading: observable,
      applicant: observable,
    });
  }

  getComponents = flow(function* () {
    this.isComponentsDataLoading = true;

    try {
      const { data } = yield OpenDrivingSchoolApi.getComponents();
      this.initialComponents = data;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.isComponentsDataLoading = false;
    }
  });

  getApplicant = flow(function* (applicantId: string) {
    this.isApplicantLoading = true;

    try {
      const { data } = yield OpenDrivingSchoolApi.getApplicant(applicantId);
      this.applicant = CaseAdapter.toFrontFormat(data);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.isApplicantLoading = false;
    }
  });

  postCommercialProposal = flow(function* ({ applicantId, selectedComponents }) {
    this.isSending = true;

    try {
      yield OpenDrivingSchoolApi.postCommercialProposal({
        driving_school_applicant_id: applicantId,
        commercial_proposal_component_ids: selectedComponents,
      });
    } catch (e) {
      this.isSending = false;
      throw e;
    }
  });

  get parsedComponents() {
    const filteredComponents = this.initialComponents.filter((component) => this.applicant[component.hide_parameter] !== true);
    return filteredComponents.map((component) => {
      const componentWithNumberTypes = { ...component };
      Object.entries(component).forEach(([key, value]) => {
        if (!Number.isNaN(Number(value))) {
          componentWithNumberTypes[key] = Number(value);
        } else {
          componentWithNumberTypes[key] = value;
        }
      });

      return CaseAdapter.toFrontFormat(componentWithNumberTypes);
    });
  }

  get componentsGroupedByCategory() {
    return this.parsedComponents.reduce((result: Record<string, ComponentsFrontendType[]>, component: ComponentsFrontendType): Record<string, ComponentsFrontendType[]> => {
      const currentResult = { ...result };
      if (currentResult.hasOwnProperty(component.categoryName)) {
        currentResult[component.categoryName].push(component);
      } else {
        currentResult[component.categoryName] = [component];
      }
      return currentResult;
    }, {});
  }
}

export default new OpenDrivingSchoolProposalStore();
